"use client";

import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Weighted, physical scroll via Lenis — mounted per-page (home, about,
 * hire), deliberately NOT in the root layout: the full-screen
 * experiences (/forest, /anatomy, /sys, /scope, /starfield) manage
 * their own scroll/wheel input and must not be intercepted.
 *
 * Respects prefers-reduced-motion (native scroll untouched).
 * `anchors: true` keeps in-page #links (./projects → #work) smooth.
 */
const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const lenis = new Lenis({ duration: 1.05, anchors: true });
    let raf = requestAnimationFrame(function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    });

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return null;
};

export default SmoothScroll;
